import { render } from "./SolucaoModalConfirmacao.vue?vue&type=template&id=c973ee24&scoped=true"
import script from "./SolucaoModalConfirmacao.vue?vue&type=script&lang=js"
export * from "./SolucaoModalConfirmacao.vue?vue&type=script&lang=js"

import "./SolucaoModalConfirmacao.vue?vue&type=style&index=0&id=c973ee24&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c973ee24"]])

export default __exports__